import { render, staticRenderFns } from "./WhatNextCard.vue?vue&type=template&id=34c1965b&scoped=true"
import script from "./WhatNextCard.vue?vue&type=script&lang=js"
export * from "./WhatNextCard.vue?vue&type=script&lang=js"
import style0 from "./WhatNextCard.vue?vue&type=style&index=0&id=34c1965b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1965b",
  null
  
)

export default component.exports